/**
 * JELSZÓMEZŐ MEGJELENÍTŐ-KAPCSOLÓVAL — a „szemgolyó" (#26/#30).
 *
 * ═══ MIÉRT KELL EGYÁLTALÁN ═══
 *
 * A NAV-kulcsbevitelen HÁROM maszkolt mező áll egymás alatt (jelszó, XML
 * aláírókulcs, XML cserekulcs), és az értékeket a rendszer TÖBBÉ NEM MUTATJA
 * MEG — a `nav-osszekottetes.md` II/9 2. alsó korlátja szerint visszaolvasni
 * nem lehet. Aki elgépel egy 44 karakteres kulcsot, arról csak a NAV
 * `INVALID_SECURITY_USER` válaszából értesül, órákkal később. A beírás
 * pillanata az EGYETLEN, amikor ellenőrizni tudja — és pont ott nem látja.
 *
 * ═══ MIÉRT GOMB, ÉS MIÉRT A MEZŐN BELÜL ═══
 *
 * A kapcsoló `<button type="button">`: enélkül az űrlapon BEKÜLDENE, és a
 * „megnézem a jelszót" mozdulat elküldené a fél kulcskészletet. A típus itt
 * nem stílus, hanem működés.
 *
 * ⚠️ A GOMB NEM KAP `tabIndex={-1}`-et. A kézenfekvő mozdulat kivenni a
 * Tab-sorrendből — „ne legyen útban" —, de ez billentyűzet-első termék (D9):
 * akkor az egérrel nem dolgozó ember soha nem érné el. Egy Tab-megálló
 * mezőnként az ára, és cserébe a funkció mindenkié.
 *
 * ═══ AMI SZÁNDÉKOSAN NINCS BENNE ═══
 *
 * Nincs automatikus visszarejtés időzítővel. Egy magától eltűnő érték a
 * gépelés közepén zavar, és hamis biztonságérzetet ad: a titok attól, hogy
 * öt másodperc múlva csillagokká válik, ugyanúgy ott volt a képernyőn. A
 * rejtés a felhasználó döntése.
 *
 * A mező NEM kezeli a `value`-t — vezérelt marad, ahogy a hívók eddig is
 * írták. Csak a `type`-ot váltja, tehát a beírt szöveg a váltáskor megmarad,
 * és a kurzor sem ugrik a végére.
 */

import { type InputHTMLAttributes, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Eye } from './Eye';

type PasswordInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

export function PasswordInput(props: PasswordInputProps) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  return (
    <span className="password">
      <input {...props} type={visible ? 'text' : 'password'} />
      <button
        type="button"
        className="password__reveal"
        // A NYOMÓGOMB ÁLLAPOTA A KÉPERNYŐOLVASÓNAK IS: az `aria-pressed`
        // mondja meg, hogy a jelszó ÉPPEN látszik-e. A felirat magában csak
        // a KÖVETKEZŐ műveletet nevezné meg, az állapotot nem.
        aria-pressed={visible}
        aria-label={visible ? t('password.hide') : t('password.show')}
        onClick={() => setVisible((current) => !current)}
      >
        {/* A jel DEKORÁCIÓ — a nevet az `aria-label` adja, ezért a
            képernyőolvasó elől el van rejtve (lásd az `Eye`-t). Az ÁTHÚZOTT
            szem azt mutatja, mi TÖRTÉNIK a kattintásra: a jelszó elrejtése.
            Fordítva a gomb azt ígérné, hogy elrejti azt, ami már rejtve van. */}
        <Eye off={visible} />
      </button>
    </span>
  );
}
